import React from 'react';
import PageKit from '../PageKit';
import { useTranslation } from 'react-i18next';

function WebApps() {
  const { t } = useTranslation();

  const text = t('WebApps.Text');

  return (
    <PageKit>
      <div style={{ padding: '56px 10vw 36px 10vw', color: 'white' }} className="global-background">
        {/* Title */}
        <div style={{ width: '100%', textAlign: 'center', fontSize: '2.2rem', fontWeight: 900, color: '#fff', letterSpacing: '-0.03em', marginBottom: '28px', textShadow: '0 2px 12px #d47d3b55' }}>
          {t('WebApps.Title')}
        </div>

        {/* Text block */}
        <div style={{
          background: 'rgba(24, 31, 65, 0.72)',
          borderRadius: '24px',
          padding: '32px',
          marginBottom: '28px',
          border: '1.5px solid #222a37'
        }}>
          <p style={{ fontSize: '1.15rem', lineHeight: 1.85, color: '#eaf6ff', margin: 0, whiteSpace: 'pre-line'}}>{text}</p>
        </div>
          
          {/* Two video placeholders, similar style to ConnectedDevices images area */}
        <div style={{
          background: 'rgba(24, 28, 48, 0.72)',
          borderRadius: '24px',
          padding: '20px',
          border: '1.5px solid #222a37'
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center' }}>
            {[0,1].map((i) => (
              <div key={i} style={{
                width: 'min(560px, 100%)',
                background: 'rgba(16, 20, 36, 0.65)',
                border: '1px solid #222a37',
                borderRadius: '16px',
                padding: '10px'
              }}>
                <video
                  controls
                  controlsList="nodownload noplaybackrate"
                  poster={`${process.env.PUBLIC_URL}/img/VisionSpace/${i === 0 ? '01' : '02'}.jpg`}
                  style={{ width: '100%', borderRadius: '10px', border: '1px solid #d47d3b22', objectFit: 'cover', aspectRatio: '16 / 9', background: '#0b0f1a' }}
                  src={`${process.env.PUBLIC_URL}/video/${i === 0 ? 'VisionSpace XR 01.mp4' : 'VisionSpace XR 02.mp4'}`}
                >
                  Your browser does not support the video tag.
                </video>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageKit>
  );
}

export default WebApps;
